import React, { useEffect } from 'react';
import { getBtnData, deleteData, getOneItemColleciton, registerDailyStockMovement } from '../../api/Api.js';
import { db } from '../../config-firebase/firebase.js';
import { doc, getDoc } from 'firebase/firestore';
import { setDoc, updateDoc } from '../../api/FirestoreInterceptor';
import style from '../../assets/styles/RequestListToBePrepared.module.scss';
import { Link } from 'react-router-dom';
import Title from '../title.js';
import { UpdateMenuMessage } from '../Messages/UpdateMenuMessage';
import {
  requestSorter,
  isOrderFullyFinished,
} from '../../Helpers/Helpers.js';
import DishRefusalModal from './DishRefusalModal';
import ConfirmFinalizarModal from './Modals/ConfirmFinalizarModal';
import OrderCard from './OrderCard';
import PdvTablesDashboard, { getPdvDisplayedElements } from './PdvTablesDashboard';
import { usePdvEditAndRefusal } from './usePdvEditAndRefusal';
import { usePdvPaymentAndDelivery } from './usePdvPaymentAndDelivery';
import { usePdvRealtimeOrders } from './usePdvRealtimeOrders';
import { usePdvAutoNfce } from './usePdvAutoNfce';
import PdvWaiterCallOverlay from './PdvWaiterCallOverlay';
import PdvLegendAndWarnings from './PdvLegendAndWarnings';
import { checkCanCancelOrders } from './pdvPermissions';
import { updateIngredientsStock, cleanObject } from './stockOperations';
import { useOrderPromotions } from './useOrderPromotions';

import DefaultComumMessage from '../Messages/DefaultComumMessage';
import { GlobalContext } from '../../GlobalContext';
import { useNavigate } from 'react-router-dom';
import { getAnonymousUser } from '../../Hooks/useEnsureAnonymousUser.js';

//import { getOneItemColleciton } from '../../api/Api';

const RequestListToBePrepared = ({ title, statusByUrl }) => {
  const [loadingAvailableMenuDishes, setLoadingAvailableMenuDishes] =
    React.useState(false);
  const [requestsDoneList, setRequestDoneList] = React.useState([]);
  const [colorStatusRequest, setColorStatusRequest] = React.useState('red');

  const global = React.useContext(GlobalContext);

  const canCancelOrders = React.useMemo(
    () => checkCanCancelOrders(global?.currentUser),
    [global?.currentUser]
  );

  const navigate = useNavigate();
  const {
    refusalModalData,
    setRefusalModalData,
    handleEditOrder,
    handleReleaseEditFromList,
    handleFinishEditFromList,
    handleRequestItemCancellation,
    handleDishRefusalSubmit,
  } = usePdvEditAndRefusal({ global, canCancelOrders });

  const [recipeModal, setRecipeModal] = React.useState({
    openModal: false,
    id: '',
  });

  // const { isOpen, toggle } = useModal();

  const [categories, setCategories] = React.useState([]);
  const [promotions, setPromotions] = React.useState([]);

  const [registeredUserIds, setRegisteredUserIds] = React.useState(new Set());
  const [usersMap, setUsersMap] = React.useState(new Map());
  const [benefitedClient, setBenefitedClient] = React.useState([]);

  const [sideDishesList, setSideDishesList] = React.useState([]);
  const [openRequests, setOpenRequests] = React.useState({});
  const [selectedTableFilter, setSelectedTableFilter] = React.useState(null);

  const [showPaymentBlockedPopup, setShowPaymentBlockedPopup] = React.useState(false);
  const [selectedItemToPay, setSelectedItemToPay] = React.useState(null);

  const {
    showFinalizarMessage,
    selectedItemToFinalize,
    openFinalizarModal,
    closeFinalizarModal,
    confirmFinalizarPedido,
    orderDelivery,
    getPostpaidButtonState,
    handleWaiterDelivery,
    ShowDefaultMessage,
    setShowDefaultMessage,
    selectedRequestId,
    openShowModal,
    closeModal,
    handleDeleteRequest,
    RequestDone,
    handlePaymentMethodChange,
    descontFinalPrice,
    unlockPayment,
    changeStatusPaid,
    payingOrders,
    getStatusAndColor,
  } = usePdvPaymentAndDelivery({
    global,
    canCancelOrders,
    setRequestDoneList,
    setLoadingAvailableMenuDishes,
    setShowPaymentBlockedPopup,
    setSelectedItemToPay,
  });

  const fetchUserRequests = async () => {
    let [requestList, usersData] = await Promise.all([
      getBtnData('requests'),
      getBtnData('user'),
    ]);
    requestList = requestList.filter((item) => item.orderDelivered === false);
    requestList = requestSorter(requestList);
    setRequestDoneList(requestList);

    if (Array.isArray(usersData)) {
      const map = new Map();
      usersData.forEach((u) => {
        if (u && u.id) {
          map.set(u.id, u);
        }
      });
      setUsersMap(map);
    }
  };

  const fetchData = async () => {
    try {
      const [promotionsData, benefitedClientData, usersData] = await Promise.all([
        getBtnData('Promotions'),
        getBtnData('BenefitedCustomer'),
        getBtnData('user'),
      ]);

      if (Array.isArray(usersData)) {
        const map = new Map();
        usersData.forEach((u) => {
          if (u && u.id) {
            map.set(u.id, u);
          }
        });
        setUsersMap(map);

        const validIds = new Set(
          usersData
            .filter((u) => u && u.name && u.name !== 'anonimo')
            .map((u) => u.id)
        );
        setRegisteredUserIds(validIds);
      }

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      const promotionsFilter = promotionsData.filter((promotion) => {
        if (!promotion?.startDate || !promotion?.finalDate ||
          typeof promotion.startDate !== 'string' || typeof promotion.finalDate !== 'string') {
          return false;
        }

        try {
          const startParts = promotion.startDate.split('-');
          const finalParts = promotion.finalDate.split('-');

          if (startParts.length !== 3 || finalParts.length !== 3) return false;

          const startDate = new Date(
            Number(startParts[0]),
            Number(startParts[1]) - 1,
            Number(startParts[2])
          );
          const finalDate = new Date(
            Number(finalParts[0]),
            Number(finalParts[1]) - 1,
            Number(finalParts[2])
          );

          return today >= startDate && today <= finalDate;
        } catch (e) {
          console.error('Erro ao processar data da promoção:', e);
          return false;
        }
      });

      setPromotions(promotionsFilter);
      setBenefitedClient(benefitedClientData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const {
    pendingWaiterCalls,
    setPendingWaiterCalls,
    pendingPaymentCalls,
    setPendingPaymentCalls,
    inspectedCalls,
    setInspectedCalls,
    inspectedPaymentCalls,
    setInspectedPaymentCalls,
    inspectedCallsRef,
    inspectedPaymentCallsRef,
    warningsEnabled,
    handleToggleWarnings,
    dismissWaiterCall,
    dismissPaymentCall,
  } = usePdvRealtimeOrders({
    setRequestDoneList,
    fetchData,
    setShowPaymentBlockedPopup,
    setSelectedItemToPay,
  });

  usePdvAutoNfce({ requestsDoneList, global });

  React.useEffect(() => {
    if (!requestsDoneList) return;
    setOpenRequests((prev) => {
      const next = {};
      requestsDoneList.forEach((item) => {
        next[item.id] = prev[item.id] ?? false;
      });
      return next;
    });
  }, [requestsDoneList]);

  useEffect(() => {
    setColorStatusRequest('red');
  }, [requestsDoneList]);


  // Hook de controle de promoções e fidelidade
  const {
    selectedPromotion,
    messagePromotionPopup,
    setMessagePromotionPopup,
    textPromotion,
    AddPromotion,
    handleSelectChange,
    addEditBenefitedClient,
  } = useOrderPromotions({
    promotions,
    benefitedClient,
    registeredUserIds,
    fetchData,
    fetchUserRequests,
  });

  const openPrintScreen = (item) => {
    global.setUserNewRequest(item);
    navigate('/print');
  };

  const toggleRequest = (id) => {
    const isCurrentlyOpen = Boolean(openRequests[id]);
    const order = requestsDoneList.find((r) => r.id === id);
    const hasActiveCall = Boolean(order?.waiterCall && order.waiterCall.active === true);
    const hasActivePaymentCall = Boolean(order?.paymentCall && order.paymentCall.active === true);

    if (!isCurrentlyOpen) {
      // Garçom está expandindo o pedido para verificar o que aconteceu
      if (hasActiveCall) {
        inspectedCallsRef.current.add(id);
        setInspectedCalls((prev) => new Set(prev).add(id));
      }
      if (hasActivePaymentCall) {
        inspectedPaymentCallsRef.current.add(id);
        setInspectedPaymentCalls((prev) => new Set(prev).add(id));
      }
    } else {
      // Garçom está recolhendo (fechando) o pedido após tê-lo inspecionado
      if (hasActiveCall && (inspectedCallsRef.current.has(id) || inspectedCalls.has(id))) {
        dismissWaiterCall(id);
      }
      if (hasActivePaymentCall && (inspectedPaymentCallsRef.current.has(id) || inspectedPaymentCalls.has(id))) {
        dismissPaymentCall(id);
      }
    }

    setOpenRequests((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div>
      <PdvWaiterCallOverlay
        warningsEnabled={warningsEnabled}
        pendingWaiterCalls={pendingWaiterCalls}
        setPendingWaiterCalls={setPendingWaiterCalls}
        pendingPaymentCalls={pendingPaymentCalls}
        setPendingPaymentCalls={setPendingPaymentCalls}
      />

      <Link to="/admin/admin">
        <Title mainTitle={title} />
      </Link>
      <div className={style.updateMenuMessageWrapper}>
        {loadingAvailableMenuDishes && <UpdateMenuMessage />}
      </div>
      <PdvLegendAndWarnings
        warningsEnabled={warningsEnabled}
        onToggleWarnings={handleToggleWarnings}
      />
      <ConfirmFinalizarModal
        isOpen={showFinalizarMessage}
        onClose={closeFinalizarModal}
        onConfirm={confirmFinalizarPedido}
      />
      {warningsEnabled && showPaymentBlockedPopup && (
        <DefaultComumMessage
          msg="O cliente ainda não pediu a conta, quer prosseguir mesmo assim?"
          onConfirm={() => {
            setShowPaymentBlockedPopup(false);
            setSelectedItemToPay(null);
          }}
          onClose={() => unlockPayment(selectedItemToPay)}
          affirmativeResponse="Entendi"
          negativeResponse="Efetuar o pagamento assim mesmo"
        />
      )}
      {(() => {
        if (!requestsDoneList || requestsDoneList.length === 0) return null;

        const renderOrderCard = (orderItem, isGroupedTable = false) => {
          return (
            <OrderCard
              key={orderItem.id}
              orderItem={orderItem}
              isGroupedTable={isGroupedTable}
              getStatusAndColor={getStatusAndColor}
              warningsEnabled={warningsEnabled}
              toggleRequest={toggleRequest}
              openRequests={openRequests}
              dismissWaiterCall={dismissWaiterCall}
              dismissPaymentCall={dismissPaymentCall}
              handlePaymentMethodChange={handlePaymentMethodChange}
              payingOrders={payingOrders}
              setSelectedItemToPay={setSelectedItemToPay}
              setShowPaymentBlockedPopup={setShowPaymentBlockedPopup}
              changeStatusPaid={changeStatusPaid}
              registeredUserIds={registeredUserIds}
              selectedPromotion={selectedPromotion}
              handleSelectChange={handleSelectChange}
              promotions={promotions}
              openShowModal={openShowModal}
              canCancelOrders={canCancelOrders}
              handleFinishEditFromList={handleFinishEditFromList}
              handleEditOrder={handleEditOrder}
              handleReleaseEditFromList={handleReleaseEditFromList}
              getPostpaidButtonState={getPostpaidButtonState}
              handleWaiterDelivery={handleWaiterDelivery}
              isOrderFullyFinished={isOrderFullyFinished}
              openFinalizarModal={openFinalizarModal}
              openPrintScreen={openPrintScreen}
              ShowDefaultMessage={ShowDefaultMessage}
              selectedRequestId={selectedRequestId}
              setShowDefaultMessage={setShowDefaultMessage}
              handleDeleteRequest={handleDeleteRequest}
              messagePromotionPopup={messagePromotionPopup}
              textPromotion={textPromotion}
              AddPromotion={AddPromotion}
              setMessagePromotionPopup={setMessagePromotionPopup}
              addEditBenefitedClient={addEditBenefitedClient}
              recipeModal={recipeModal}
              setRecipeModal={setRecipeModal}
              setRefusalModalData={setRefusalModalData}
              handleRequestItemCancellation={handleRequestItemCancellation}
              descontFinalPrice={descontFinalPrice}
              usersMap={usersMap}
            />
          );
        };

        const displayedElements = getPdvDisplayedElements(
          requestsDoneList,
          selectedTableFilter
        );

        return (
          <>
            {/* Painel Superior: Pós-pago Mesas & Pré-pago + Barra de Filtro */}
            <PdvTablesDashboard
              requestsDoneList={requestsDoneList}
              selectedTableFilter={selectedTableFilter}
              onSelectTable={(table) =>
                setSelectedTableFilter((prev) => (prev === table ? null : table))
              }
              onClearFilter={() => setSelectedTableFilter(null)}
            />

            {/* Lista de Pedidos Ordenada por Mesa (menor para maior) */}
            {displayedElements.map((element) => {
              if (element.type === 'tableGroup') {
                const tableHasWaiterCall = element.orders.some((o) => o.waiterCall && o.waiterCall.active === true);
                const tableHasActiveBillCall = element.orders.some((o) => o.paymentCall && o.paymentCall.active === true);
                const tableHasPendingBill = element.orders.some((o) => o.paymentCall && (!o.paymentDone || !o.orderDelivered));
                const tableHasDelivery = element.orders.some((o) => o.request && o.request.some((r) => r.pronto && !r.entregue));

                let tableBlinkClass = '';
                if (tableHasWaiterCall) {
                  tableBlinkClass = style.blinkingWaiterCallTable;
                } else if (tableHasActiveBillCall) {
                  tableBlinkClass = style.blinkingPaymentTable;
                } else if (tableHasDelivery) {
                  tableBlinkClass = style.blinkingDeliveryTable;
                }

                return (
                  <div
                    className={`${style.tableGroupWrapper} ${tableBlinkClass}`}
                    key={element.key}
                    data-testid={`table-group-${element.tableNumber}`}
                  >
                    <div className={style.tableGroupHeader}>
                      <div className={style.tableGroupTitle}>
                        <span>Mesa: <strong>{element.tableNumber}</strong></span>
                        {tableHasWaiterCall && (
                          <span className={`${style.statusAlertBadge} ${style.waiterCall}`}>
                            🔔 Garçom Chamado
                          </span>
                        )}
                        {tableHasPendingBill && (
                          <span className={`${style.statusAlertBadge} ${style.payment}`}>
                            💰 Pediu a Conta
                          </span>
                        )}
                        {tableHasDelivery && (
                          <span className={`${style.statusAlertBadge} ${style.delivery}`}>
                            🍽️ Prato Pronto
                          </span>
                        )}
                      </div>
                      <span className={style.tableGroupBadge}>
                        {element.orders.length} pedidos nesta mesa
                      </span>
                    </div>
                    {element.orders.map((tableOrder) =>
                      renderOrderCard(tableOrder, true)
                    )}
                  </div>
                );
              }

              return renderOrderCard(element.order, false);
            })}
          </>
        );
      })()}

      {refusalModalData && (
        <DishRefusalModal
          dish={refusalModalData.dish}
          order={refusalModalData.order}
          itemIndex={refusalModalData.itemIndex}
          onClose={() => setRefusalModalData(null)}
          onSubmit={handleDishRefusalSubmit}
        />
      )}
    </div>
  );
};
export default RequestListToBePrepared;

///admin/requestlist
